(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    

  (() => {
    const elementName = 'soft-error-bios';

    if (customElements.get(elementName)) return;

    // Shared for this document, including section reconnects and multiple heroes.
    let navigationCancelled = false;
    let autoScrollClaimed = false;

    customElements.define(
      elementName,
      class SoftErrorBios extends HTMLElement {

        connectedCallback() {
          if (this.cleanup) return;

          const abort = new AbortController();

          const listenerOptions = {
            signal: abort.signal
          };

          const reducedMotion =
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            );

          const pauseButton =
            this.querySelector(
              '.se-bios__pause'
            );

          const integrity =
            this.querySelector(
              '[data-integrity]'
            );

          const errors =
            this.querySelector(
              '[data-errors]'
            );

          const uptime =
            this.querySelector(
              '[data-uptime]'
            );

          const decoderStatus =
            this.querySelector(
              '[data-decoder-status]'
            );

          const outputStatus =
            this.querySelector(
              '[data-output-status]'
            );

          const productLoader =
            this.querySelector(
              '[data-product-loader]'
            );

          const productState =
            this.querySelector(
              '[data-product-state]'
            );

          const bufferLabel =
            this.querySelector(
              '[data-buffer-label]'
            );

          const revealRows = [
            ...this.querySelectorAll(
              '[data-reveal]'
            )
          ];

          const productPreviews = [
            ...this.querySelectorAll(
              '[data-product-preview]'
            )
          ];

          const enabled =
            this.dataset.enabled !== 'false';

          /*
           * Existing duration setting remains the complete loop length.
           *
           * 0 - 8.7 timeline units:
           * active system narrative.
           *
           * 8.7 - 12:
           * quiet final-brand hold.
           */

          const duration =
            Math.max(
              10,
              Number(
                this.dataset.duration
              ) || 12
            ) * 1000;

          let paused = false;
          let visible = true;

          let elapsed = 0;
          let lastTimestamp = 0;

          let timer = null;

          /*
           * ONE-TIME PRODUCT NAVIGATION
           * Use the next visible Shopify section; keep the link URL as a
           * fallback if the hero has no following section.
           */

          let autoScrollTimer = null;
          let firstLoopCompleted = false;

          const findProductsTarget = () => {
            const heroSection = this.closest('.shopify-section');
            if (!heroSection) return null;

            let sibling = heroSection.nextElementSibling;

            while (sibling) {
              if (
                sibling.matches('.shopify-section')
                && !sibling.hidden
                && sibling.getClientRects().length
                && getComputedStyle(sibling).visibility !== 'hidden'
              ) {
                return sibling;
              }

              sibling = sibling.nextElementSibling;
            }

            return null;
          };

          const clearAutoScroll = () => {
            if (autoScrollTimer !== null) {
              window.clearTimeout(autoScrollTimer);
              autoScrollTimer = null;
            }
          };

          const cancelAutoScroll = () => {
            navigationCancelled = true;
            clearAutoScroll();
          };

          const scrollToProducts = target => {
            target.scrollIntoView({
              // 'instant' also overrides a theme's CSS smooth-scroll rule.
              behavior: reducedMotion.matches ? 'instant' : 'smooth',
              block: 'start'
            });
          };

          const scheduleAutoScroll = () => {
            if (
              firstLoopCompleted
              || navigationCancelled
              || autoScrollClaimed
            ) return;

            firstLoopCompleted = true;

            if (
              reducedMotion.matches
              || window.Shopify?.designMode
              || this.hasAttribute('data-shopify-visual-preview')
            ) return;

            autoScrollClaimed = true;

            autoScrollTimer = window.setTimeout(() => {
              autoScrollTimer = null;

              if (
                navigationCancelled
                || !this.isConnected
                || document.hidden
                || reducedMotion.matches
                || !shouldTick()
              ) return;

              const bounds = this.getBoundingClientRect();
              if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;

              const target = findProductsTarget();
              if (!target) return;

              // Mark navigation before scrolling generates any scroll events.
              navigationCancelled = true;
              scrollToProducts(target);
            }, 700);
          };

          const interactionOptions = {
            ...listenerOptions,
            capture: true,
            passive: true
          };

          // Capture intent immediately, including a swipe or wheel at a page edge.
          ['pointerdown', 'mousedown', 'touchstart', 'wheel', 'click', 'focusin'].forEach(
            type => document.addEventListener(
              type,
              cancelAutoScroll,
              interactionOptions
            )
          );

          // Also catches scrollbar dragging and restored/programmatic navigation.
          window.addEventListener('scroll', cancelAutoScroll, interactionOptions);

          document.addEventListener('keydown', event => {
            if ([
              'Tab', 'Enter', ' ', 'Spacebar',
              'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
              'PageUp', 'PageDown', 'Home', 'End'
            ].includes(event.key)) {
              cancelAutoScroll();
            }
          }, interactionOptions);

          // Do not override a deep link or a restored scroll position.
          if (window.scrollY > 0 || window.location.hash || reducedMotion.matches) {
            cancelAutoScroll();
          }

          this.querySelector('.se-bios__enter')?.addEventListener('click', event => {
            cancelAutoScroll();

            // Preserve explicit modified-click navigation and the no-target URL.
            if (
              event.defaultPrevented
              || event.button !== 0
              || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
            ) return;

            const target = findProductsTarget();
            if (!target) return;

            event.preventDefault();
            scrollToProducts(target);
          }, listenerOptions);


          /*
           * --------------------------------------------------------------
           * RANDOMIZED PRODUCT
           * --------------------------------------------------------------
           */

          if (productPreviews.length) {
            const selectedProduct =
              productPreviews.find(
                product =>
                  product.classList.contains(
                    'is-selected'
                  )
              )
              ||
              productPreviews[
                Math.floor(
                  Math.random()
                  * productPreviews.length
                )
              ];

            selectedProduct.classList.add(
              'is-selected'
            );

            const image =
              selectedProduct.querySelector(
                '[data-product-image]'
              );

            if (
              image
              && image.dataset.src
            ) {
              image.src =
                image.dataset.src;

              image.alt =
                image.dataset.alt || '';

              /*
               * Three very narrow duplicates simulate individual corrupted
               * raster bands while reusing the exact same network resource.
               */

              if (
                !selectedProduct.querySelector(
                  '.se-bios__fragment'
                )
              ) {
                [
                  'one',
                  'two',
                  'three'
                ].forEach(
                  band => {
                    const fragment =
                      image.cloneNode(false);

                    fragment.removeAttribute(
                      'data-product-image'
                    );

                    fragment.removeAttribute(
                      'data-src'
                    );

                    fragment.removeAttribute(
                      'data-alt'
                    );

                    fragment.alt = '';

                    fragment.className =
                      `se-bios__fragment se-bios__fragment--${band}`;

                    image.parentElement.append(
                      fragment
                    );
                  }
                );
              }
            }
          }

          /*
           * --------------------------------------------------------------
           * RENDER
           * --------------------------------------------------------------
           */

          const render = () => {
            const t =
              (
                (elapsed % duration)
                / duration
              )
              * 12;

            /*
             * More time is intentionally reserved for the clean final
             * Soft Error state than in the original sequence.
             */

            const phase =
              t < 1.4
                ? 'boot'
                : t < 3.6
                  ? 'diagnostics'
                  : t < 6.3
                    ? 'error'
                    : t < 7.9
                      ? 'dialog'
                      : t < 8.7
                        ? 'accept'
                        : 'ready';

            this.dataset.phase =
              phase;

            /*
             * Automatic "YES" selection remains decorative.
             */

            this.toggleAttribute(
              'data-selected',
              t >= 7.15
              && t < 8.7
            );

            /*
             * Failure begins as the product reaches its maximum render.
             */

            const imageError =
              t >= 3.6
              && t < 8.7;

            this.toggleAttribute(
              'data-image-error',
              imageError
            );

            /*
             * Product begins rendering shortly after boot starts and reaches
             * exactly 70% before the buffer fault.
             */

            const progress =
              Math.min(
                70,
                Math.max(
                  0,
                  (
                    (t - 0.85)
                    / 2.65
                  )
                  * 70
                )
              );

            if (productLoader) {
              productLoader.style.setProperty(
                '--se-product-progress',
                `${progress}%`
              );
            }

            /*
             * Diagnostic data.
             */

            if (integrity) {
              integrity.textContent =
                t >= 3.6
                  && t < 8.7
                  ? 'UNKNOWN'
                  : '99.8%';
            }

            if (errors) {
              errors.textContent =
                t >= 3.6
                  && t < 8.7
                  ? '001'
                  : '000';
            }

            if (uptime) {
              const seconds =
                Math.min(
                  99,
                  Math.floor(t)
                );

              uptime.textContent =
                `00:00:${String(seconds).padStart(2, '0')}`;
            }

            if (decoderStatus) {
              decoderStatus.textContent =
                imageError
                  ? 'FAULT'
                  : 'OK';
            }

            if (outputStatus) {
              outputStatus.textContent =
                imageError
                  ? 'DEGRADED'
                  : 'READY';
            }

            if (productState) {
              if (t < 1.4) {
                productState.textContent =
                  'WAITING';
              } else if (t < 3.6) {
                productState.textContent =
                  'READING';
              } else if (t < 8.7) {
                productState.textContent =
                  'BUFFER FAULT';
              } else {
                productState.textContent =
                  'HALTED';
              }
            }

            if (bufferLabel) {
              bufferLabel.textContent =
                `BUFFER ${String(
                  Math.round(progress)
                ).padStart(3, '0')}/100`;
            }

            /*
             * Reveal rows only as the relevant boot time is reached.
             */

            revealRows.forEach(
              row => {
                const revealAt =
                  Number(
                    row.dataset.reveal
                  );

                row.style.opacity =
                  t >= revealAt
                    ? '1'
                    : '0';
              }
            );
          };

          /*
           * --------------------------------------------------------------
           * LOOP MANAGEMENT
           * --------------------------------------------------------------
           */

          const shouldAnimate = () =>
            enabled
            && !reducedMotion.matches;

          const shouldTick = () =>
            shouldAnimate()
            && !paused
            && visible
            && !document.hidden;

          const stopTimer = () => {
            if (timer !== null) {
              window.clearTimeout(
                timer
              );

              timer = null;
            }

            this.removeAttribute(
              'data-running'
            );
          };

          const tick = () => {
            if (!shouldTick()) {
              stopTimer();
              return;
            }

            const now =
              performance.now();

            if (!lastTimestamp) {
              lastTimestamp = now;
            }

            elapsed +=
              now - lastTimestamp;

            lastTimestamp =
              now;

            // The actual timeline has completed its full duration, including
            // the ready-state hold. Paused/offscreen time is already excluded.
            if (elapsed >= duration) {
              scheduleAutoScroll();
            }

            render();

            timer =
              window.setTimeout(
                tick,
                80
              );
          };

          const startTimer = () => {
            stopTimer();

            if (!shouldTick()) return;

            this.setAttribute(
              'data-running',
              ''
            );

            lastTimestamp =
              performance.now();

            timer =
              window.setTimeout(
                tick,
                80
              );
          };

          /*
           * Unlike the original implementation:
           *
           * - pausing does not send the interface to ready
           * - focus does not send the interface to ready
           * - leaving the viewport does not reset the sequence
           */

          const sync = ({
            resetForMotion = false
          } = {}) => {
            stopTimer();

            const canAnimate =
              shouldAnimate();

            if (pauseButton) {
              pauseButton.hidden =
                !canAnimate;

              pauseButton.textContent =
                paused
                  ? 'PLAY ANIMATION'
                  : 'PAUSE ANIMATION';

              pauseButton.setAttribute(
                'aria-pressed',
                String(paused)
              );
            }

            if (!canAnimate) {
              this.dataset.phase =
                'ready';

              this.removeAttribute(
                'data-image-error'
              );

              this.removeAttribute(
                'data-selected'
              );

              return;
            }

            if (resetForMotion) {
              elapsed = 0;
              lastTimestamp = 0;

              render();
            }

            startTimer();
          };

          /*
           * Initial state.
           */

          if (shouldAnimate()) {
            elapsed = 0;

            render();

            startTimer();
          } else {
            this.dataset.phase =
              'ready';
          }

          /*
           * --------------------------------------------------------------
           * EVENTS
           * --------------------------------------------------------------
           */

          pauseButton?.addEventListener(
            'click',
            () => {
              paused =
                !paused;

              sync();
            },
            listenerOptions
          );

          reducedMotion.addEventListener(
            'change',
            () => {
              if (reducedMotion.matches) cancelAutoScroll();

              sync({
                resetForMotion:
                  !reducedMotion.matches
              });
            },
            listenerOptions
          );

          document.addEventListener(
            'visibilitychange',
            () => {
              // A pending transition must not surprise someone returning later.
              if (document.hidden && autoScrollTimer !== null) cancelAutoScroll();

              sync();
            },
            listenerOptions
          );

          const observer =
            'IntersectionObserver'
            in window
              ? new IntersectionObserver(
                  entries => {
                    visible =
                      Boolean(
                        entries[0]
                          ?.isIntersecting
                      );

                    sync();
                  },
                  {
                    rootMargin:
                      '120px 0px'
                  }
                )
              : null;

          observer?.observe(
            this
          );

          /*
           * --------------------------------------------------------------
           * CLEANUP
           * --------------------------------------------------------------
           */

          this.cleanup = () => {
            clearAutoScroll();
            stopTimer();

            observer?.disconnect();

            abort.abort();
          };
        }

        disconnectedCallback() {
          this.cleanup?.();

          this.cleanup =
            null;
        }

      }
    );
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
